import { render } from "./feature-item.vue?vue&type=template&id=5d7a3733&scoped=true"
import script from "./feature-item.vue?vue&type=script&lang=js"
export * from "./feature-item.vue?vue&type=script&lang=js"

import "./feature-item.vue?vue&type=style&index=0&id=5d7a3733&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d7a3733"]])

export default __exports__